import { useFieldHelper, LinkField } from 'framework/ui/field';
import React from 'react';
import { Box } from '@mui/material';
import useRedmineUrl from 'infrastructure/integrations/redmine/useRedmineUrl';

const RedmineLinkField = ({ source }: { source: string }) => {
  const { getValue } = useFieldHelper<string[]>({ source });
  const redmineLink = getValue();
  const { getIssueUrl } = useRedmineUrl();

  const redmineElements = () => {
    return redmineLink.map((redmine, index) => {
      return (
        <React.Fragment key={redmine}>
          {index > 0 && ', '}
          <LinkField key={redmine} isInternal={false} linkText={redmine} value={getIssueUrl(Number(redmine))} />
        </React.Fragment>
      );
    });
  };

  return <Box>{redmineLink?.length > 0 ? redmineElements() : <>-</>}</Box>;
};
export default RedmineLinkField;
